module.exports = __webpack_public_path__ + "media/ask/lady-city-pad-64c8e31d.svg";